import { render, staticRenderFns } from "./OrderRequirementsList.vue?vue&type=template&id=acfb611e"
import script from "./OrderRequirementsList.vue?vue&type=script&lang=js"
export * from "./OrderRequirementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports